import { SITE } from "@/config/site";

export const Logo = ({ light = false }) => (
  <img
    src={light ? "/brand/logo-blanco.webp" : "/brand/logo.webp"}
    alt={`${SITE.brand} · ${SITE.tagline}`}
    width="800" height="167"
    className="h-14 w-auto max-w-full sm:h-16"
    data-testid="brand-logo"
  />
);
